import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Container } from 'reactstrap';
import CommonStore from '../stores/commonStore';
import getLogoSrc from '../utilities/logoSrc';
import qualitystore from '../../QualityOfCare/stores/QualityStore';


@observer
class Header extends Component {

  constructor(props) {
    super(props);

    const params =  window.location.pathname.split('/');
    if (params.length > 0 && params[2]) {
      qualitystore.updateStateCode(params[2]);
    } else {
      // for local testing use stateCode - NE or MO or NC
      qualitystore.updateStateCode("NC");
    }
  }

  render() {
    const { commonStore } = this.props;
    const { appName } = commonStore;
    const imgSrc = getLogoSrc(qualitystore.stateCode);
    return (
      <div>
        <Container className="appHeaderAlignment">
          <h1 className="page-header page-header-brand">
            <div className="page-header-title">{appName}</div>
            <img src={ imgSrc } alt="appLogo" className="float-md-right d-inline-block" />
          </h1>
        </Container>
    </div>
    );
  }
}

export default Header;

Header.propTypes = {
  commonStore: PropTypes.oneOf([CommonStore])
};
